<template>
    <attribution-brand v-bind="$attrs" />
</template>

<script>
// Since brand anc club pages are very similar, for now we're using the same component
import AttributionBrand from "@/pages/attribution/AttributionBrand";

export default {
    name: "AttributionClub",
    components: {
        AttributionBrand
    }
};
</script>
